module.exports = __webpack_public_path__ + "static/media/video.7d73370a.png";